<script setup lang="ts">import { createPropsRestProxy } from '/vue-macros/reactivity-transform/helper';
const content = createPropsRestProxy(__props, ["item","root"]);

import { computed } from "vue";

import { useBrandStore } from "@/stores/brand-store";

import Tooltip from "@/components/Tooltip/Tooltip.vue";

import type { TooltipContentProps, TooltipRootProps } from "reka-ui";

withDefaults(defineProps<{ item: string[]; root?: TooltipRootProps } & TooltipContentProps>(), {  })

const highlightColors = computed(() => useBrandStore().viewerConfig.evidenceThemes?.highlightColors ?? {});
</script>
<template>
  <Tooltip :content-props="content" :root-props="root">
    <template #trigger>
      <slot :disabled="root?.disabled" />
    </template>
    <template #content>
      <ul class="tw-space-y-1">
        <li v-for="theme in item" :key="theme" class="tw-flex tw-items-center tw-justify-start tw-gap-2">
          <span class="tw-size-2 tw-rounded-md" :style="{ backgroundColor: highlightColors[theme] }" />
          <p>{{ theme }}</p>
        </li>
      </ul>
    </template>
  </Tooltip>
</template>
